const TrinidadAndTobagoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112584)">
      <path
        d="M10.8292 2.22168C9.03875 3.14582 7.35805 4.35715 5.85711 5.85809C4.35609 7.3591 3.14477 9.0398 2.2207 10.8303L15.0806 24.92L29.1704 37.78C30.9609 36.8558 32.6416 35.6445 34.1426 34.1436C35.6436 32.6426 36.8548 30.9619 37.779 29.1714L24.9191 15.0816L10.8292 2.22168Z"
        fill="#F0F0F0"
      />
      <path
        d="M34.1427 34.1428C34.9817 33.3038 35.73 32.4086 36.3888 31.4696L8.53055 3.61133C7.59156 4.27 6.69633 5.01828 5.85734 5.85727C5.01836 6.69625 4.27008 7.59148 3.61133 8.53055L31.4695 36.3887C32.4084 35.73 33.3038 34.9818 34.1427 34.1428Z"
        fill="black"
      />
      <path
        d="M5.85718 34.1425C12.1671 40.4524 21.6434 41.6636 29.1705 37.7788L2.22085 10.8291C-1.66391 18.3561 -0.452428 27.8325 5.85718 34.1425Z"
        fill="#D80027"
      />
      <path
        d="M34.1429 5.85728C27.833 -0.452562 18.3566 -1.66381 10.8296 2.2208L37.7792 29.1706C41.664 21.6436 40.4528 12.1671 34.1429 5.85728Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112584">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TrinidadAndTobagoSvg;
